module.exports = __webpack_public_path__ + "static/media/background.dcf009ff.jpg";